import React, { Component } from "react";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import {
    getFacturaOrdenes,
    postFacturaOrdenes,
    fetchMotivosSolicitudAnulacionApi,
    // fetchOrdenEstadoVentaApi — estado interno deshabilitado
    postSolicitudAnulacionOrdenApi,
    postAnulacionReversionOrdenApi
} from '../../../api/axios';
// import EstadoVentaAdm from "./EstadoVentaAdm"; /* estado interno deshabilitado */
import EstadoListItem from "./EstadoListItem";
import SolicitudAnulacion from "./SolicitudAnulacion";
import AnulacionReversion from "./AnulacionReversion";
import UploadFile from "../../General/UploadFile";
import ModalItem from '../../General/Modal';
import FormularioDevolucion from './FormularioDevolucion';
import FormularioDevolucionVte from './FormularioDevolucionVte';
import StatusTimeline from "../../General/StatusTimeline";
import { toast } from 'react-toastify';
import { formatFile, base64ToArrayBuffer, saveByteArray } from "../../../utilities/formatFile";
import { filtroHoySplitted, filtroHoy } from "../../../utilities/fechasFiltro";
import { idEstadosOrden } from "../../../helper/ordenHelper";
import { buildOrderTimeline } from "../../../helper/statusTimelineHelper";
import PropTypes from 'prop-types';

// Wrapper para usar hooks en class component
function EstadosOrdenWrapper(props) {
    const navigate = useNavigate();
    return <EstadosOrden {...props} navigate={navigate} />;
}
const fechaHoySplitted = filtroHoySplitted();
const idEstados = idEstadosOrden;

class EstadosOrden extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estados: [...this.props.orden.estado].reverse(),
            factura: "",
            notaDeCredito: "",
            filaFacturado: false,
            filaAnulado: false,
            btnFacturar: false,
            btnAnular: false,
            fechaFacturado: "",
            fechaAnulado: "",
            clickEliminarFactura: false,
            clickEliminarAnulado: false,
            facturaCargada: false,
            anuladaCargada: false,
            motivosSolicitudAnulacion: [],
            habilitarInputs: false,
            setHabilitarInputsVte: false,
            montoDevolver: "",
            cuentaBancaria: "",
            cuil: "",
            numeroComprobante: "",
            banco: "",
            numCuenta: "",
            cbu: "",
            alias: "",
            dni: "",
            showModalDevolucion: false,
            idMotivoAnulacion: "",

        }
    }

    componentDidMount() {
        this.props.orden.estado.forEach((item) => {
            if (item.idEstado == idEstados.facturado) {
                this.cargarFactura();
                this.setState({
                    facturaCargada: true,
                    filaFacturado: true,
                    btnFacturar: true,
                    fechaFacturado: item.fecha.slice(0, 10)
                })
            }

            if (item.idEstado == idEstados.anulado) {
                this.setState({
                    anuladaCargada: true,
                    filaAnulado: true,
                    btnAnular: true,
                    fechaAnulado: item.fecha.slice(0, 10)
                })
            }
        });

        const orden = this.props.orden;
        if (
            orden?.anulacionMegatone?.anulado === true &&
            !orden.estado?.some((e) => e.idEstado === idEstados.anulado)
        ) {
            this.setState({
                anuladaCargada: true,
                filaAnulado: true,
                btnAnular: true,
                fechaAnulado: filtroHoy()
            });
        }

        const { isSellerAdmin, isSeller, isAdminMod, isCategory } = this.props.userType;
        if (isSellerAdmin || isSeller || isAdminMod || isCategory) {
            let request = fetchMotivosSolicitudAnulacionApi();
            request.then(res => {
                const motivos = Array.isArray(res.motivosSolicitudAnulacion)
                    ? res.motivosSolicitudAnulacion
                    : [];

                this.setState({ motivosSolicitudAnulacion: motivos });
            }).catch(err => {
                toast.error("No se encontraron motivos para solicitud de anulaci�n");
            });
        }
        /* Estado interno deshabilitado
        if (this.props.orden?.idOrden && this.props.userId) {
            fetchOrdenEstadoVentaApi({
                idUsuario: this.props.userId,
                idVenta: this.props.orden.idOrden
            }).then((res) => {
                this.setState({ estadoVentaAprobado: res?.estado !== "Anulado" });
            }).catch(() => {
                this.setState({ estadoVentaAprobado: null });
            });
        }
        */
    }

    onSubmit = (event) => {
        event.preventDefault();

        const {
            montoDevolver,
            titularCompra,
            banco,
            numCuenta,
            cbu,
            cuil,
            alias,
            dni,
            numeroComprobante,
            cupon,
            cuponVTE,
            terminal,
            tarjeta,
            cuotas,
            autorizacion,
            autorizacionVTE
        } = this.state;

        const datosCuentaBancaria = {
            montoADevolver: montoDevolver,
            titularCompra: titularCompra,
            banco: banco,
            numCuenta: numCuenta,
            cbu: cbu,
            cuil: cuil,
            alias: alias,
            dni: dni,
            numeroComprobante: numeroComprobante,
            cupon: cupon && !Number.isNaN(Number.parseInt(cupon)) ? Number.parseInt(cupon) : null,
            autorizacion: autorizacion && !Number.isNaN(Number.parseInt(autorizacion)) ? Number.parseInt(autorizacion) : null,
        };

        const anulacionVTE = {
            cuponVTE: cuponVTE && !Number.isNaN(Number.parseInt(cuponVTE)) ? Number.parseInt(cuponVTE) : null,
            terminal: terminal?.trim() || null,
            tarjeta: tarjeta?.trim() || null,
            cuotas: cuotas && !Number.isNaN(Number.parseInt(cuotas)) ? Number.parseInt(cuotas) : null,
            autorizacionVTE: autorizacionVTE && !Number.isNaN(Number.parseInt(autorizacionVTE)) ? Number.parseInt(autorizacionVTE) : null,
        };

        const isCuentaBancariaVacia = Object.values(datosCuentaBancaria).every(
            (value) => value === "" || value === null || value === undefined
        );

        const isAnulacionVTEVacia = Object.values(anulacionVTE).every(
            (value) => value === "" || value === null || value === undefined
        );

        const cleanAnulacionVTE = (obj) => {
            if (!obj) return null;

            const cleaned = Object.entries(obj).reduce((acc, [key, val]) => {
                if (
                    val !== null &&
                    val !== undefined &&
                    val !== '' &&
                    !(typeof val === 'number' && Number.isNaN(val))
                ) {
                    acc[key] = val;
                }
                return acc;
            }, {});

            return Object.keys(cleaned).length === 0 ? null : cleaned;
        };

        const anulacionVTEFinal = cleanAnulacionVTE(anulacionVTE);


        const request = {
            idVenta: this.props.orden.idOrden,
            idSeller: this.props.idSeller,
            idMotivoAnulacion: Number.isNaN(Number.parseInt(this.state.idMotivoAnulacion, 1))
                ? null
                : Number.parseInt(this.state.idMotivoAnulacion, 1),
            solicitarAnulacion: true
        };

        postSolicitudAnulacionOrdenApi(request)
            .then(res => {
                toast.success("Solicitud de anulaci�n enviada");
                const requestAnulacion = {
                    idVenta: this.props.orden.idOrden,
                    devolucionDinero: true,
                    rechazado: false,
                    idSeller: this.props.idSeller,
                    idMotivoAnula: Number.parseInt(this.state.idMotivoAnulacion),
                    //solicitarAnulacion: true,
                    anulacionVTE: isAnulacionVTEVacia ? null : anulacionVTEFinal,
                    datosCuentaBancaria: isCuentaBancariaVacia ? null : datosCuentaBancaria
                };
                return postAnulacionReversionOrdenApi(requestAnulacion);
            })
            .then(res => {
                toast.success("Estado de orden actualizado");
                this.goToOrdenes();
            })
            .catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("Faltan datos en el formulario");
            });
    };




    cargarFactura = () => {
        let factura = getFacturaOrdenes(this.props.orden.idOrden, idEstados.facturado);

        factura.then(res => {
            this.setState({ factura: res.estado });
        }).catch(err => {
            toast.error("Descarga fallida");
        });
    }

    descargarFactura = (e) => {
        let factura = getFacturaOrdenes(this.props.orden.idOrden, e.target.id);
        factura.then(res => {
            let pdfData = base64ToArrayBuffer(res);
            saveByteArray("Factura", pdfData);
            toast.success("Descarga realizada");
        }).catch(err => {
            toast.error("Descarga fallida");
        });
    }

    descargarFacturaAdmin = (e) => {
        let pdfData = base64ToArrayBuffer(e.target.id);
        saveByteArray("Factura", pdfData);
        toast.success("Descarga realizada");
    }

    inputCreditoFile = async (dataPdf) => {
        let pdfFormatted = await formatFile(dataPdf, "pdf");
        this.setState({ notaDeCredito: pdfFormatted });
    }

    inputFacturaFile = async (dataPdf) => {
        let one_week = this.checkDaysToUploadFactura();

        if (!one_week) {
            toast.warn("No puede subir / eliminar la factura pasados los 7 dias de facturado");
            return;
        }

        let pdfFormatted = await formatFile(dataPdf, "pdf");
        this.setState({ factura: pdfFormatted });
    }

    checkDaysToUploadFactura = () => {
        let date = new Date();
        let today = new Date().now();
        let sevenDaysAgo = date.setDate(date.getDate() - 8);
        let fechaFacturado = new Date(this.state.fechaFacturado.replaceAll("-", "/")).now();

        if (Number.isNaN(fechaFacturado)) {
            return true;
        }

        return sevenDaysAgo <= fechaFacturado && today >= fechaFacturado;
    }

    eliminarFilaFacturado = () => {
        this.setState(prevState => ({
            clickEliminarFactura: prevState.facturaCargada,
            btnFacturar: false,
            filaFacturado: false,
            estados: prevState.estados.filter(estado => estado.updateFacturado !== true)
        }));
    }

    eliminarFilaAnulado = () => {
        this.setState(prevState => ({
            clickEliminarAnulado: prevState.anuladaCargada,
            filaAnulado: false,
            btnAnular: false,
            estados: prevState.estados.filter(estado => estado.updateAnulado !== true)
        }));
    }

    agregarFacturado = () => {
        const newEstadoFacturado = {
            idEstado: idEstadosOrden.facturado,
            fecha: filtroHoy(),
            updateFacturado: true
        }

        this.setState(prevState => ({
            filaFacturado: true,
            btnFacturar: true,
            estados: prevState.estados.concat([newEstadoFacturado]),
            updateFacturado: true
        }));
    }

    postArchivoFactura = () => {
        let data = {
            "idSeller": this.props.orden.seller.codigo,
            "idOrden": this.props.orden.idOrden,
            "idEstado": idEstados.facturado,
            "comprobante": this.state.factura
        }

        const req = postFacturaOrdenes(data);
        req.then(res => {
            toast.success("Factura creada");
            this.goToOrdenes();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse");
        });
    }

    postArchivoNota = () => {
        if (this.state.clickEliminarFactura) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.pendiente,
                "comprobante": ""
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de credito creada");
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }

        let data = {
            "idSeller": this.props.orden.seller.codigo,
            "idOrden": this.props.orden.idOrden,
            "idEstado": idEstados.anulado,
            "comprobante": this.state.notaDeCredito
        }

        const req = postFacturaOrdenes(data);
        req.then(res => {
            toast.success("Nota de credito creada");
            this.goToOrdenes();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse");
        });
    }

    eliminarFactura = () => {
        let data = {
            "idSeller": this.props.orden.seller.codigo,
            "idOrden": this.props.orden.idOrden,
            "idEstado": idEstados.pendiente,
            "comprobante": this.state.factura || ""
        }

        const req = postFacturaOrdenes(data);
        req.then(res => {
            toast.success("Factura eliminada");
            this.goToOrdenes();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse");
        });
    }

    eliminarAnulado = () => {
        if (this.state.facturaCargada && !this.state.clickEliminarFactura) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.facturado,
                "comprobante": this.state.factura
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de cr�dito eliminada");
                this.goToOrdenes();
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }

        if (this.state.facturaCargada && this.state.clickEliminarFactura) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.pendiente,
                "comprobante": this.state.notaDeCredito
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de cr�dito eliminada");
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }
    }

    estadoPendiente = () => {
        if (this.state.anuladaCargada && this.state.clickEliminarAnulado) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.pendiente,
                "comprobante": ""
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de cr�dito eliminada");
                this.goToOrdenes();
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }
    }

    postArchivo = (e) => {
        e.preventDefault();
        this.estadoPendiente();

        const {
            factura,
            facturaCargada,
            filaAnulado,
            filaFacturado,
            clickEliminarFactura,
            clickEliminarAnulado,
            fechaFacturado
        } = this.state

        if (facturaCargada && filaAnulado) {
            this.postArchivoNota();
            return;
        }

        if (!filaFacturado && clickEliminarFactura) {
            this.eliminarFactura();
        }

        if (!filaAnulado && clickEliminarAnulado) {
            this.eliminarAnulado();
        }

        if (filaFacturado) {
            if (!factura) {
                toast.warn("El comprobante de factura es requerido");
                return;
            }
            this.postArchivoFactura();
        }

        if (filaAnulado) {
            if (!factura && fechaFacturado != "") {
                toast.warn("El comprobante de factura es requerido");
                return;
            }
            this.postArchivoNota();
        }
    }

    handleSetIdMotivoAnulacion = (idMotivo) => {
        this.setState({ idMotivoAnulacion: idMotivo });
    };

    goToOrdenes = () => {
        this.props.navigate("/Ordenes");
    }


    render() {
        const { userType, orden } = this.props;
        const isCategoryOrAdmin = userType.isCategory || userType.isAdminMod;
        const isSellerAdminOrIsSeller = userType.isSellerAdmin || userType.isSeller;
        const isSoloLectura = userType.isSoloLectura;
        const { fechaAnulado, fechaFacturado } = this.state;
        const timelineItems = buildOrderTimeline(orden, null); // estado interno deshabilitado: antes this.state.estadoVentaAprobado
        const existeAnulado = orden?.estado?.some(e => e.idEstado === 5);
        const anuladaMegatone = orden?.anulacionMegatone?.anulado === true;
        const ocultarFacturadoPorAnulacion =
            existeAnulado || this.state.anuladaCargada || anuladaMegatone;
        const estadosSinFacturado = ocultarFacturadoPorAnulacion
            ? this.state.estados.filter((e) => e.idEstado !== idEstados.facturado)
            : this.state.estados;
        const estadosParaMostrar =
            anuladaMegatone && !estadosSinFacturado.some((e) => e.idEstado === idEstados.anulado)
                ? [
                    ...estadosSinFacturado,
                    { idEstado: idEstados.anulado, fecha: this.state.fechaAnulado || filtroHoy() }
                ]
                : estadosSinFacturado;
        const idEstadoParaSolicitud =
            existeAnulado || anuladaMegatone
                ? idEstados.anulado
                : this.props.orden.estado[0]?.idEstado;

        let mesAnulado = fechaAnulado?.slice(5, 7);
        let diaAnulado = fechaAnulado?.slice(8, 10);
        let mesFacturado = fechaFacturado?.slice(5, 7);
        let diaFacturado = fechaFacturado?.slice(8, 10);

        let btnEliminarAnulado = true;
        let btnEliminarFacturado = true;

        if (Number.parseInt(mesAnulado) <= fechaHoySplitted.mes || Number.parseInt(diaAnulado) <= fechaHoySplitted.dia) {
            btnEliminarAnulado = false;
        }

        if (Number.parseInt(mesFacturado) < fechaHoySplitted.mes || Number.parseInt(diaFacturado) < fechaHoySplitted.dia) {
            btnEliminarFacturado = false;
        }
        return (
            <div className="tab-pane p-10 active row" name="datos" id="home2" role="tabpanel">

                {(!isSellerAdminOrIsSeller) &&
                    <AnulacionReversion
                        idOrden={this.props.orden.idOrden}
                        idSeller={this.props.idSeller}
                        motivosRechazo={this.props.motivosRevision}
                        goToOrdenes={this.goToOrdenes}
                        orden={this.props.orden}
                        setHabilitarInputs={(value) => this.setState({ habilitarInputs: value })}
                        setHabilitarInputsVte={(value) => this.setState({ habilitarInputsVte: value })}
                        motivoAnulacionSeller={{
                            ...this.props.orden.motivoAnulacion,
                            idMotivo: this.state.idMotivoAnulacion !== "" && this.state.idMotivoAnulacion !== undefined
                                ? this.state.idMotivoAnulacion
                                : (this.props.orden.motivoAnulacion?.idMotivo ?? this.props.orden.motivoAnulacion?.id)
                        }}
                        isCategory={userType.isCategory}
                        isAdminMod={userType.isAdminMod}
                        motivosSolicitudAnulacion={this.state.motivosSolicitudAnulacion}
                        idMotivoAnulacion={this.state.idMotivoAnulacion}
                        setIdMotivoAnulacion={this.handleSetIdMotivoAnulacion}
                    />
                }

                {isSellerAdminOrIsSeller &&
                    <div className="col-12">
                        <div className="row p-1 align-content-center">

                            {/* Bot�n "Cambiar a Facturado" oculto en todas las vistas
                            <div className="col-auto">
                                {!this.state.btnFacturar &&
                                    <button
                                        className="btn m-r-10 btn-sm btn-grey mb-md-2"
                                        type="button"
                                        onClick={this.agregarFacturado}
                                        disabled={this.state.anuladaCargada}
                                    >
                                        Cambiar a Facturado
                                    </button>
                                }
                            </div>
                            */}

                            {/*boton solicitud anulacion + motivo � solo seller / seller admin*/}
                            <div className="col-auto">
                                <SolicitudAnulacion
                                    idOrden={this.props.orden.idOrden}
                                    idEstado={idEstadoParaSolicitud}
                                    idSeller={this.props.idSeller}
                                    motivoSolicitudOrden={this.props.orden.motivoAnulacion}
                                    motivosAnulacion={this.state.motivosSolicitudAnulacion}
                                    goToOrdenes={this.goToOrdenes}
                                    idMotivoAnulacion={this.state.idMotivoAnulacion}
                                    setIdMotivoAnulacion={this.handleSetIdMotivoAnulacion}
                                    isSellerAdminOrIsSeller={isSellerAdminOrIsSeller}
                                    orden={this.props.orden}
                                />
                            </div>

                        </div>
                    </div>
                }

                <div className="col-12">
                    <StatusTimeline
                        title="Estados de la orden"
                        subtitle="Seguimiento visual del circuito de la venta"
                        items={timelineItems}
                    />
                </div>

                <div className={`col-12 col-lg-${isCategoryOrAdmin ? "9" : "12"}`}>
                    {estadosParaMostrar.map((estado, index) => {
                        return (
                            <EstadoListItem key={estado.idEstado ?? index} idEstado={estado.idEstado} fecha={estado.fecha}>
                                {/* // PENDIENTE � motivo rechazo solo si el estado actual es pendiente (p. ej. tras rechazo de anulaci�n), no mezclar con solicitud de anulaci�n vigente */}
                                {estado.idEstado === idEstados.pendiente &&
                                    this.props.orden.estado?.[0]?.idEstado === idEstados.pendiente &&
                                    Number(this.props.orden.motivoAnulacion?.id ?? this.props.orden.motivoAnulacion?.idMotivo) > 0 &&
                                    <div className="form-group col-12 col-sm-4">
                                        <label htmlFor="motivoRechazoEstadosOrden">Motivo de rechazo</label>
                                        <select
                                            id="motivoRechazoEstadosOrden"
                                            className="form-control"
                                            disabled={true}
                                            defaultValue={this.props.orden.motivoAnulacion?.id ?? this.props.orden.motivoAnulacion?.idMotivo}
                                        >
                                            <option value={this.props.orden.motivoAnulacion?.id ?? this.props.orden.motivoAnulacion?.idMotivo}>
                                                {this.props.orden.motivoAnulacion?.detalle ?? ""}
                                            </option>
                                        </select>
                                    </div>
                                }
                                {/* // FACTURADA */}
                                {estado.idEstado === idEstados.facturado &&
                                    this.state.filaFacturado &&
                                    this.state.btnFacturar &&
                                    <>
                                        {!isSoloLectura && /*Adjuntar comprobante*/
                                            <div className="col-2 col-md-3">
                                                <UploadFile
                                                    acceptType={".pdf"}
                                                    inputId={"inputFacturaFile"}
                                                    onFileLoaded={this.inputFacturaFile}
                                                />
                                            </div>
                                        }

                                        <div className="col-3">
                                        <button
                                            className="btn btn-sm background-rojo-megatone waves-light mx-1"
                                            type="button"
                                            onClick={this.descargarFactura}
                                            id={idEstados.facturado}
                                        >
                                            Descargar Factura</button>
                                        </div>

                                        {btnEliminarFacturado &&
                                            <div className="col-2">
                                                <ModalItem
                                                    text="�Desea eliminar el estado Facturado?"
                                                    onDelete={this.eliminarFilaFacturado}
                                                    hidden={isSoloLectura}
                                                    btnText="Eliminar"
                                                    btnStyle="btn m-r-10 btn-sm btn-grey"
                                                />
                                            </div>
                                        }
                                    </>
                                }
                                {/* // SOLICITUD ANULACION � sellers ven el motivo; Megatone si la solicitud sigue vigente y hay motivo */}
                                {estado.idEstado === idEstados.solicitarAnulacion &&
                                    (isSellerAdminOrIsSeller ||
                                        (this.props.orden.estado?.[0]?.idEstado === idEstados.solicitarAnulacion &&
                                            Number(this.props.orden?.motivoAnulacion?.id ?? this.props.orden?.motivoAnulacion?.idMotivo) > 0)) &&
                                    <div className="form-group col-12 col-sm-4">
                                        <label htmlFor="motivoAnulacionEstadosOrden">Motivo de anulaci�n</label>
                                        <select
                                            id="motivoAnulacionEstadosOrden"
                                            className="form-control"
                                            disabled={true}
                                            defaultValue={this.props.orden?.motivoAnulacion?.id ?? this.props.orden?.motivoAnulacion?.idMotivo}
                                        >
                                            <option value={this.props.orden?.motivoAnulacion?.id ?? this.props.orden?.motivoAnulacion?.idMotivo}>
                                                {this.props.orden.motivoAnulacion?.detalle ?? ""}
                                            </option>
                                        </select>
                                    </div>
                                }

                             

                                {/* // ANULADA */}
                                {estado.idEstado === idEstados.anulado &&
                                    this.state.filaAnulado &&
                                    this.state.btnAnular &&
                                    <>
                                        {!isSoloLectura &&
                                            <div className="col-2 col-md-3">
                                                <UploadFile
                                                    acceptType={".pdf"}
                                                    inputId={"inputCreditoFile"}
                                                    onFileLoaded={this.inputCreditoFile}
                                                />
                                            </div>
                                        }

                                        <div className="col-3">
                                            <button
                                                className="btn btn-sm background-rojo-megatone waves-light mx-1"
                                                onClick={this.descargarFactura}
                                                id={idEstados.anulado}
                                            >
                                                Descargar Nota de Cr�dito
                                            </button>
                                        </div>

                                        {btnEliminarAnulado &&
                                            <div className="col-2">
                                                <ModalItem
                                                    text="�Desea eliminar el estado Anulado?"
                                                    onDelete={this.eliminarFilaAnulado}
                                                    hidden={isSoloLectura}
                                                    btnText="Eliminar"
                                                    btnStyle="btn m-r-10 btn-sm btn-grey"
                                                />
                                            </div>
                                        }
                                    </>
                                }
                            </EstadoListItem>
                        )
                    })
                    }
                </div>

                {isCategoryOrAdmin &&
                    <div className="col-12 col-lg-3 mt-4 mt-lg-0">
                        <div className="row justify-content-center border-2 border-start">

                            {/* Estado interno (switch admin) deshabilitado
                            <div className="col-6">
                                <EstadoVentaAdm
                                    userId={this.props.userId}
                                    idOrden={this.props.orden.idOrden}
                                    onStatusChange={(estadoVentaAprobado) => this.setState({ estadoVentaAprobado })}
                                />
                            </div>
                            */}

                            <div className="col-6 text-center" hidden={orden.pago?.linkFactura ?? true}>
                                <button
                                    className="btn btn-sm background-rojo-megatone waves-light"
                                    onClick={this.descargarFacturaAdmin}
                                    id={orden.pago?.linkFactura}
                                >
                                    Descargar Factura Megatone
                                </button>
                            </div>

                        </div>
                    </div>
                }

                {!isSoloLectura &&
                    <form className="form-horizontal form-material mt-3">
                        <div className="tab-content">
                            <div className="row align-items-center justify-content-center">
                                <button
                                    className="col-auto btn btn-sm background-rojo-megatone waves-light"
                                    onClick={this.postArchivo}
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </form>
                }

                <FormularioDevolucion
                    show={this.state.habilitarInputs}
                    onClose={() => this.setState({ habilitarInputs: false })}
                    montoDevolver={this.state.montoDevolver}
                    cuentaBancaria={this.state.cuentaBancaria}
                    titularCompra={this.state.titularCompra}
                    banco={this.state.banco}
                    cuil={this.state.cuil}
                    numCuenta={this.state.numCuenta}
                    cbu={this.state.cbu}
                    alias={this.state.alias}
                    dni={this.state.dni}
                    numeroComprobante={this.state.numeroComprobante}
                    cupon={this.state.cupon}
                    autorizacion={this.state.autorizacion}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                    onSubmit={this.onSubmit}
                />


                <FormularioDevolucionVte
                    show={this.state.habilitarInputsVte}
                    onClose={() => this.setState({ habilitarInputsVte: false })}
                    cuponVTE={this.state.cuponVTE}
                    autorizacionVTE={this.state.autorizacionVTE}
                    terminal={this.state.terminal}
                    tarjeta={this.state.tarjeta}
                    cuotas={this.state.cuotas}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                    onSubmit={this.onSubmit}
                />



            </div>
        );
    }
}
EstadosOrden.propTypes = {
    navigate: PropTypes.func,
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    orden: PropTypes.shape({
        estado: PropTypes.arrayOf(PropTypes.shape({
            idEstado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })),
        idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        seller: PropTypes.shape({
            codigo: PropTypes.string,
        }),
        motivoAnulacion: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            detalle: PropTypes.string,
            idMotivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        pago: PropTypes.shape({
            linkFactura: PropTypes.string,
        }),
        anulacionMegatone: PropTypes.shape({
            anulado: PropTypes.bool,
        }),
    }),
    userType: PropTypes.shape({
        isSellerAdmin: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
        isSeller: PropTypes.bool,
        isSoloLectura: PropTypes.bool,
    }),
    motivosRevision: PropTypes.array,
}

const mapStateToProps = state => ({
    orden: state.ordenes.orden,
    userId: state.general.userId,
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    motivosRevision: state.publicaciones.motivosRevision
});

export default connect(mapStateToProps)(EstadosOrdenWrapper);
